import { publicRequest } from "../../../requestMeth";
import {
  companiesStart, companiesSuccess, companiesFailure, deleteStart, deleteSuccess, deleteFailure
} from "../../reducers/master/companiesRedux"


export const getAllcompanies = async (dispatch, token, selected, id) => {
  dispatch(companiesStart());
  try {
    let url = `/master/companies?type=${selected}`;
    if (id) url += `&id=${id}`;

    const res = await publicRequest.get(url, {
      headers: { token: `Bearer ${token}` }
    });
    if(res.data.privilege === "master" || res.data.privilege === "admin-master"){
      dispatch(companiesSuccess(res.data))
    }else {
        dispatch(companiesFailure())
    }
    dispatch(companiesSuccess(res.data))
    return res.data
  } catch (error) {
    dispatch(companiesFailure());
  }
};

export const deletecompany = async (dispatch, id, selected, token) =>{
  dispatch(deleteStart())
  try {
    const res = await publicRequest.delete(`/master/company/delete/${id}?type=${selected}`, {
      headers: { token: `Bearer ${token}` }
    });
      dispatch(deleteSuccess(res.data));
  } catch (error) {
      dispatch(deleteFailure())
  }
}
